module.exports = __webpack_public_path__ + "img/filmi_logo_bl.c074ae1d.svg";